<template>
  <v-menu open-on-hover bottom offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        id="no-background-hover"
        v-on="on"
        icon
        small
        class="grey mr-5"
        @click="logout"
      >
        <v-badge content="" value="" color="secondary" overlap>
          <v-icon medium>mdi-logout</v-icon>
        </v-badge>
      </v-btn>
      <v-btn to="/settings" id="no-background-hover" plain style="color: black">
        <v-icon
          v-if="!currentUser.picture_file_path"
          class="mr-3"
          medium
          color="black"
          >mdi-account-circle</v-icon
        >
        <v-avatar v-else size="40" class="mr-3">
          <v-img contain :src="currentUser.picture_file_path"></v-img>
        </v-avatar>
        {{ currentUser.firstname }}
      </v-btn>
      <v-badge :value="unreadNotifications" dot overlap color="secondary">
        <v-icon @click="showNotifications()">mdi-bell-outline</v-icon>
      </v-badge>
      <UserNotifications ref="notifications" @unreadNotification="setUnreadNotification" :currentUser="user" />
    </template>
  </v-menu>
</template>

<script>
import logo from '../../../assets/manushare.png'
import { mapActions, mapState } from 'vuex'
import UserNotifications from '../dialogs/UserNotifications.vue'

export default {
	components: { UserNotifications },
	name: 'Notification',
	props: {
		currentUser: Object
	},
	data: () => ({
		logo,
		unreadNotifications: 0
	}),
	computed: {
		...mapState('auth', ['user'])
	},
	methods: {
		...mapActions(
			'auth',
			['logout']
		),
		showNotifications () {
			this.$refs.notifications.show()
		},
		setUnreadNotification (count) {
			this.unreadNotifications = count
		}
	}
}
</script>

<style scoped>
#no-background-hover {
  background-color: transparent !important;
  border-color: transparent !important;
}

.v-select {
  width: 5%;
}

.text-head {
  font-family: "Karla";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 23px;
  display: flex;
  align-items: center;
  letter-spacing: -0.02em;

  /* Primär Farbe */

  color: #303941;
}
</style>
